import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Box } from "@mui/material";
import { EffectCoverflow, Pagination } from "swiper/modules";

type ReactSwiperCustProps = {
  Images: string[];
  handleStepImgCount: any;
};

const ReactSwiperCust: React.FC<ReactSwiperCustProps> = ({
  Images = [],
  handleStepImgCount,
}) => {
  const handleSlideChange = (swiper: any) => {
    handleStepImgCount(swiper?.activeIndex);
  };
  return (
    <>
      <Swiper
        effect={"coverflow"}
        grabCursor={true}
        onSlideChange={handleSlideChange}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 50,
          stretch: 1,
          depth: 100,
          modifier: 1,
          slideShadows: true,
        }}
        pagination={true}
        modules={[EffectCoverflow, Pagination]}
      >
        {Images?.length > 0 &&
          Images?.map(
            (image, index) =>
              image && (
                <SwiperSlide key={index}>
                  <Box
                    component={"img"}
                    src={image}
                    alt={`Slide ${index + 1}`}
                  />
                </SwiperSlide>
              )
          )}
      </Swiper>
    </>
  );
};

export default ReactSwiperCust;
